























































































































import { Component, Mixins } from 'vue-property-decorator';

import authApi from '@/api/auth';
import membersApi from '@/api/members';

import BlogMixin, { WebStorage } from '@/mixins/blog';

import Loader from '@/components/loader/Loader.vue';
import BlogItem from '@/components/blog/BlogItem.vue';

import { openWebView } from '@/utils/scheme';

enum Domain {
  VIEW = 'view',
  STATIC = 'static'
}

@Component({
  components: {
    Loader,
    BlogItem
  }
})
export default class ServiceGuide extends Mixins(BlogMixin) {
  goGuideDetails(domain: Domain, scheme: string) {
    switch (domain) {
      case Domain.VIEW:
        scheme = `${process.env.VUE_APP_DOMAIN}${scheme}`;
        break;

      case Domain.STATIC:
        scheme = `${process.env.VUE_APP_STATIC_DOMAIN}${scheme}`;
        break;
    }

    openWebView(scheme);
  }

  learnMoreAboutKasa() {
    openWebView(`${process.env.VUE_APP_DOMAIN}/help/guide/learn-kasa`);
  }

  async initBlogItems() {
    try {
      try {
        const cachedBlogItems = this.loadFromWebStorage();
        if (cachedBlogItems && this.blogItems.length === 0) {
          this.setBlogItems(cachedBlogItems.slice(0, 5));
        } else if (this.blogItems.length > 0) {
          this.setBlogItems(this.blogItems.slice(0, 5));
        } else {
          this.setIsLoading(true);
          const items = await this.fetchBlogItems(5);
          this.setBlogItems(items);
          this.setIsLoading(false);
        }
      } catch (error) {
        this.setIsLoading(true);
        const items = await this.fetchBlogItems(5);
        this.setBlogItems(items);
        this.setIsLoading(false);
      }
    } catch (error) {
      this.setBlogItems([]);
      this.setIsLoading(false);
    }
  }

  async fetchAllBlogItems() {
    try {
      const cachedBlogItems = this.loadFromWebStorage(WebStorage.local);
      if (cachedBlogItems) {
        this.setBlogItems(cachedBlogItems);
      } else {
        const items = await this.fetchBlogItems();
        this.cacheToWebStorage(items, WebStorage.local);
      }
    } catch (error) {
      console.error('FAILED fetchBlogItems');
    }
  }

  created() {
    this.clearWebStorage(WebStorage.local);
    this.initBlogItems();
    this.fetchAllBlogItems();
  }
}
